import { BaseScheduleIndex } from '../../../../../@paco/entities/BaseSchedule/BaseSchedule'
import { PublishBaseScheduleFormData } from '../../../../../entities/ShiftConcept/ShiftConcept'

const generateEmptyPublishBaseScheduleFormDataValues = (
    startDate: Date,
    endDate: Date,
    baseSchedules: BaseScheduleIndex[] = [],
): PublishBaseScheduleFormData => ({
    startDate,
    endDate,
    baseScheduleId: baseSchedules.length ? baseSchedules[0].id : '',
})

export default generateEmptyPublishBaseScheduleFormDataValues
